// extracted by mini-css-extract-plugin
export default {"categorySelector":"CategoryTypeController_categorySelector__g9BHO"};